import React, { useEffect, useState } from 'react'
import { CircularProgress, Tabs, Tab, Box } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import CenteredContent from '../CenteredContent'
import { useTranslation } from 'react-i18next'
import { Reports } from './Reports'
import { get, getBlob } from '../rest-utils'
import IdentifiedReports from './IdentifiedReports'
import resources from '../resources'

const reportsPageSize = Number(process.env.REPORTS_PAGE_SIZE ?? 10)

const AirportReportsPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const navigate = useNavigate()
  const [identifiedReports, setIdentifiedReports] = useState<Reports | undefined | null>()
  const [selectedAirportIcao, setSelectedAirportIcao] = useState<string | undefined>()
  const [currentTabIndex, setCurrentTabIndex] = useState<number>(0)

  useEffect(() => {
    if (params.airportIcao === selectedAirportIcao) {
      return
    }
    setSelectedAirportIcao(params.airportIcao || undefined)
    setIdentifiedReports(undefined)

    get<Reports>(`reports/all?airportIcao=${params.airportIcao}&pageSize=${reportsPageSize}&pageNumber=0`)
      .then((airportsReportsResult) => {
        const promises = airportsReportsResult.reportsList.map((report) =>
          getBlob(`screenshots?key=${report.registrationScreenshotKey}`),
        )
        Promise.all(promises).then((screenshots) => {
          // eslint-disable-next-line
          const reportsTemp: Reports = { reportsList: [], airportIcao: params.airportIcao! }
          for (let i = 0; i < airportsReportsResult.reportsList.length; i++) {
            const reportTemp = { ...airportsReportsResult.reportsList[i] }
            reportTemp.registrationScreenshotURL = URL.createObjectURL(screenshots[i])
            reportsTemp.reportsList.push(reportTemp)
          }
          setIdentifiedReports(reportsTemp)
        })
      })
      .catch((e) => {
        if (403 === e) {
          navigate('../403')
        } else if (404 === e) {
          navigate('../404')
        } else if (500 === e) {
          navigate('../500')
        } else {
          setIdentifiedReports(null)
        }
      })
  }, [selectedAirportIcao, navigate, params])

  if (identifiedReports === undefined || identifiedReports?.reportsList === undefined) {
    return (
      <CenteredContent>
        <CircularProgress />
      </CenteredContent>
    )
  } else {
    return (
      <React.Fragment>
        <Box sx={{ width: '100%', height: 'calc(100vh - 64px)' }}>
          <Box sx={{ width: '100%', height: 'calc(100vh - 114px)' }}>
            <IdentifiedReports initialReports={identifiedReports} />
          </Box>
        </Box>
      </React.Fragment>
    )
  }
}

export default AirportReportsPage
